import { render, staticRenderFns } from "./MonlamDefinition.vue?vue&type=template&id=38c794ec&scoped=true"
import script from "./MonlamDefinition.vue?vue&type=script&lang=js"
export * from "./MonlamDefinition.vue?vue&type=script&lang=js"
import style0 from "./MonlamDefinition.vue?vue&type=style&index=0&id=38c794ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c794ec",
  null
  
)

export default component.exports